import { Component, Listen } from '@stencil/core';

@Component({
  tag: 'staedtler-toggle-search',
})
export class ToggleSearch {
  @Listen('click')
  onClick() {
    document.body.classList.toggle('searchbox-active');
    if (document.body.classList.contains('searchbox-active')) {
      const inputElement = <HTMLInputElement>document.querySelector('.searchbox .form-control');
      inputElement.focus();
    }
  }
}
